<template>
  <v-stepper
    :key="render"
    v-model="el"
    tile
    flat
  >
    <v-stepper-header style="height: 55px;justify-content: flex-start;box-shadow: none">
      <template>
        <div
          v-for="(page, index) in def.pages.filter((p,index)=>pagesVisible[index])"
          :key="`${page.id}-step`"
        >
          <v-stepper-step
            style="height: 55px; font-size: 12px!important"
            :step="index + 1"
            :complete="index + 1 < el"
            :editable="mode === 'ECore.Def.DefEnums.fmView'"
            edit-icon="$complete"
            :color="index === el - 1 && 'S1' || 'P1'"
            :class="index=== el - 1 && 'step-slider'"
          >
            {{ $t(page) }}
          </v-stepper-step>
        
          <v-divider
            v-if="(index + 1) !== def.pages.length"
            :key="index + 1"
            style="max-width: 120px"
            class="mx-1"
          ></v-divider>
        </div>
      </template>
    </v-stepper-header>
    <v-divider></v-divider>
    <v-stepper-items>
      <v-stepper-content
        v-for="(page, index) in def.pages"
        :key="`${page.id}-step`"
        class="pa-0"
        :step="index + 1"
      >
        <AbrPageContainer
          v-if="loadedPages[index]"
          :def="def"
          :model="model"
          :modal="modal"
          :mode="mode"
          :page="page"
        />
        <v-divider v-if="def.footer || def.footer === undefined"></v-divider>
        <AppFooter
          v-if="def.footer || def.footer === undefined"
          class="BG1"
          style="height: 6.7vh"
        >
          <AppPortalTarget
            :name="`${def.id}.footerActions`"
          ></AppPortalTarget>
          <AppButton
            v-for="action in page.actions && page.actions.filter(act => act.actionLocation && act.actionLocation.name === 'ECore.Def.DefEnums.Footer')"
            :key="action.id"
            :def="{ form: def, ...action }"
            :model="{...Model , lastStep : (el === def.pages.filter((p,index)=>pagesVisible[index]).length)}"
            :modal="modal"
            :mode="mode"
            :outlined="action.name === 'fcaCancelButton'"
            class="mx-2"  
            @click.native="clickStep(action)"
          >
            <template #label>
              {{ $t(action) }}
            </template>
          </AppButton>
        </AppFooter>
      </v-stepper-content>
    </v-stepper-items>
  </v-stepper>
</template>

<script>
import { cloneDeep } from "@/utils/object";
import AbrPageContainer from "./AbrPageContainer";
import AppButton from "./library/action/AppButton";
import AppFooter from "./library/container/AppFooter";
import AppPortalTarget from "@/components/library/portal/AppPortalTarget"

export default {
  name: "AbrStepper",
  components: {AbrPageContainer, AppButton, AppFooter , AppPortalTarget},
  props: ["def", "model", "modal", "mode", "formValidate", "save"],
  data: (vm) => ({
    Model: vm.model,
    el: -1,
    loadedPages: [1],
    pagesVisible: [],
    render: false
  }),


  async created() {
    if(this.el<1){
      if(this.$store.state.formSteps[this.def.name]){
        if(this.$store.state.formSteps[this.def.name].step){
          this.el = this.$store.state.formSteps[this.def.name].step;
        }else{
          this.el = 1;
        }
      }else{
        this.el = 1;
      }
    }

    this.pagesVisible = await Promise.all(this.def.pages?.map(p => this.$checkVisibility(p)) || []);
    //this.def.pages = this.def.pages.filter((page, index) => pagesVisible[index]);

    // this.$watch("mode", (nv) => {
    //   if(nv === "ECore.Def.DefEnums.fmView") {
    //   this.def.pages.forEach((p, i) => this.loadedPages[i] = i+1);
    //   }
    // },{immediate : true})

    this.$watch("el", nv => {
      
      if(!this.modal) {
        this.$route.meta[this.def.name] = { activeStep: nv };

        const { modelId } = this.$store.state.formSteps[this.def.name]
        if(this.Model.ID === modelId) {
          const cloneFromState = Object.assign(this.$store.state.formSteps[this.def.name], {})
          cloneFromState.step = nv ?? 1
          this.$store.commit('ADD_OR_REPLACE_FORM_STEP', {[this.def.name]:cloneFromState})
        }
      }
      if(this.$store.state.formSteps[this.def.name])this.$store.state.formSteps[this.def.name].step = this.el ;
      if(this.loadedPages[nv - 1]) return;
      // this.loadedPages.push(nv - 1);
      this.$set(this.loadedPages, nv - 1, nv - 1);
    }, { immediate: true });
  },

  async mounted(){
    this.$eventBus.$on(`${this.def.name}-rerender`,async (newModel)=>{
      this.assign(this.model, newModel)
      this.render = !this.render
      await this.setFromStep()   
    }) 
    await this.setFromStep()
  },

  beforeDestroy() {
    this.$store.dispatch('REMOVE_FORM_STEP', this.def.name)
    this.$eventBus.$off(`${this.def.name}-rerender`)
  },
  methods: {
    async clickStep(action) {
 if(action.tags === "goBack") {
    this.changeStep("decrement");
    return;
  }

if (action.tags === "goNext") {
  const validateStep = await this.formValidate(this.el - 1)
  if (!validateStep) return

  try {
    const successPromise = new Promise((resolve) => {
      const eventName = `${action.id}-action-success-complete`
      const handler = () => {
        this.$eventBus.$off(eventName, handler)
        resolve()
      }
      this.$eventBus.$on(eventName, handler)
    })
    await this.save(action, this.el - 1)
    await successPromise
  } catch (err) {
    return
  }
  this.changeStep("increment")
  return
}

if (action.tags === "fcaNextButton") {

  const eventName = `${action.id}-action-success-complete`

  const successPromise = new Promise((resolve) => {
    const handler = () => {
      this.$eventBus.$off(eventName, handler)
      console.log("SUCCESS:", eventName)
      resolve()
    }

    this.$eventBus.$on(eventName, handler)
  })
  try {
    await this.save(action, this.el - 1)
    await successPromise
  } catch (e) {
    console.log("SAVE ERROR:", e)
    return
  }
  this.changeStep("increment")
  return
}
      if(action.name === "fcaBackButton") {
        this.changeStep("decrement");
        return;
      } else if(action.name === "fcaNextButton" ) {
        if(this.el === this.def.pages.length) {
          await this.save({ ...action, name: "fcaSubmitButton" }, this.el - 1) // must execute as the same as submit button
          return;
        }
        const validateStep = await this.formValidate(this.el - 1);
        if(validateStep) {
          // if(this.mode === 'ECore.Def.DefEnums.fmEdit') {
          //   this.render = !this.render;
          // }
          if (action.tags === "stay") {
            this.changeStep("stay")
            return
          }
          this.changeStep("increment");
        }
        return;
      }
      const res = await this.save(action, this.el - 1); // call method form AbrFormContainer
      if(res) {
        if(this.mode === 'ECore.Def.DefEnums.fmEdit') {
          this.render = !this.render;
        }
        if (action.tags === "stay") {
            this.changeStep("stay")
            return
          }
        this.changeStep("increment");
      }
    },
    changeStep(kind) {
      switch(kind) {
        case "increment":
          if(this.el < this.def.pages.length)
            this.el++;
          break;
        case "decrement":
          if(this.el > 0)
            this.el--;
          break;
        default:
          break;
      }
    },
    setFromStep(){
      const cloneTabStep =  cloneDeep(this.$store.state.formSteps[this.def.name] || {})
      const {canReset, step, modelId } = cloneTabStep
      
      if(!canReset && this.Model.ID === modelId || Object.hasOwn(cloneTabStep, 'force') && this.$store.state.formSteps[this.def.name].force){
        this.el = step ?? 1
      }
    },
    assign(target, source) {
      if (source){
        for (let k of Object.keys(source)) this.$set(target, k, source[k]);
      }
      return target;
    },
    
  }
}
</script>
<style>
.v-stepper__items .search-in-stepper .v-data-table__wrapper {
  max-height: 51vh!important;
}
.step-slider {
  position: relative;
}
.step-slider:before{
  content: "";
  position: absolute;
  bottom: -2%;
  left: 50%;
  width: 100%;
  height: 2px;
  background: #F6921D;
  border-radius: 25px;
  transform: translate(-50%, -50%);
  z-index: 9
}
</style>